const searchVendorStock = async (searchValue, dataHouse) => {
    if (searchValue.trim() === '') {
        // If the search term is empty, return the whole array
        return dataHouse;
    }
    const searchData = await dataHouse.filter((data) => {
        return data.vendor_name.toLowerCase().includes(searchValue.toLowerCase());
    });
    return searchData;
};

export {
    searchVendorStock
};
